export const config = {
  apiBaseUrl: 'api.doss.com',
  protocol: 'https',
  websocketProtocol: 'wss',
  isProduction: true,
  isStaging: false,
}
